import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const IsyeriHekimiPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'İşyeri Hekimi | Adana OSGB Mersin Hatay Osmaniye | ASSA İş Sağlığı';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana işyeri hekimi, Mersin işyeri hekimi, Hatay işyeri hekimi, Osmaniye işyeri hekimi hizmetleri. Sağlık muayeneleri, periyodik kontroller, sağlık gözetimi. ASSA OSGB profesyonel işyeri hekimi desteği.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana işyeri hekimi, Mersin işyeri hekimi, Hatay işyeri hekimi, Osmaniye işyeri hekimi, OSGB işyeri hekimi, iş sağlığı hekimi');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/osgb/isyeri-hekimi');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "İşyeri Hekimi Hizmetleri",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde profesyonel işyeri hekimi hizmetleri. Sağlık muayeneleri, periyodik kontroller, sağlık gözetimi.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "telephone": "+90-850-346-2772",
        "email": "assa@assaisg.com"
      },
      "areaServed": [
        {"@type": "City", "name": "Adana"},
        {"@type": "City", "name": "Mersin"},
        {"@type": "City", "name": "Hatay"},
        {"@type": "City", "name": "Osmaniye"}
      ],
      "serviceType": "İşyeri Hekimi",
      "url": "https://www.assaosgb.com.tr/osgb/isyeri-hekimi"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-red-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              İşyeri Hekimi Hizmetleri
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde profesyonel işyeri hekimi hizmetleri sunuyoruz. Çalışanlarınızın sağlığını korumak için uzman kadromuzla yanınızdayız.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              İşyeri Hekimi Hizmetlerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service Card 1 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-heart-pulse-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Muayeneleri</h3>
                <p className="text-gray-600">
                  İşe giriş, periyodik ve işten çıkış muayeneleri ile çalışan sağlığını takip ediyoruz. <strong>Adana işyeri hekimi</strong> hizmetlerimiz kapsamında düzenli kontroller yapılır.
                </p>
              </div>

              {/* Service Card 2 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-list-3-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Raporları</h3>
                <p className="text-gray-600">
                  Çalışanlarınız için gerekli tüm sağlık raporlarını hazırlıyoruz. <strong>Mersin OSGB işyeri hekimi</strong> olarak mevzuata uygun raporlama yapıyoruz.
                </p>
              </div>

              {/* Service Card 3 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İş Sağlığı Takibi</h3>
                <p className="text-gray-600">
                  Çalışma ortamı sağlık gözetimi ve meslek hastalıkları takibi. <strong>Hatay OSGB</strong> bölgesinde güvenilir hizmet sunuyoruz.
                </p>
              </div>

              {/* Service Card 4 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-first-aid-kit-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İlk Yardım Organizasyonu</h3>
                <p className="text-gray-600">
                  İşyerinde ilk yardım ekiplerinin oluşturulması ve eğitimi. <strong>Osmaniye işyeri hekimi</strong> hizmetlerimizle acil durumlara hazırlıklı olun.
                </p>
              </div>

              {/* Service Card 5 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-stethoscope-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Gözetimi</h3>
                <p className="text-gray-600">
                  Çalışanların sağlık durumlarının düzenli takibi ve değerlendirilmesi. <strong>Adana OSGB</strong> standartlarında hizmet.
                </p>
              </div>

              {/* Service Card 6 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-hospital-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Revir Hizmetleri</h3>
                <p className="text-gray-600">
                  İşyeri revir kurulumu ve yönetimi. <strong>Mersin işyeri hekimi</strong> olarak profesyonel destek sağlıyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Hizmet Bölgelerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adana OSGB</h3>
                <p className="text-gray-600">
                  Adana ve çevresinde <strong>işyeri hekimi</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Mersin OSGB</h3>
                <p className="text-gray-600">
                  Mersin bölgesinde profesyonel <strong>işyeri hekimi</strong> desteği
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hatay OSGB</h3>
                <p className="text-gray-600">
                  Hatay'da güvenilir <strong>işyeri hekimi</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Osmaniye OSGB</h3>
                <p className="text-gray-600">
                  Osmaniye'de uzman <strong>işyeri hekimi</strong> kadrosu
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-red-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              İşyeri Hekimi Hizmeti Almak İster misiniz?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde profesyonel işyeri hekimi hizmetleri için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim" 
                className="bg-white text-red-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                Hemen İletişime Geçin
              </Link>
              <a 
                href="tel:08503462772" 
                className="bg-red-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-red-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                0850 346 2772
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IsyeriHekimiPage;
